import React, { Component } from 'react'
// import DataGrid from "../../components/DataGrid";
// import Pagination from "../../components/Pagination";
// import FinancialBox from "../../components/boxes/FinancialBox";
// import ProductViewBox from './ProductViewBox';
import SidebarView from '../../components/SidebarView';
import { checkTranslation, getObject, imageAddress, phoneStandardView, priceStandardView, translate } from '../../utils/useful';
// import Collapsible from 'react-collapsible';
import Responsive from '../../components/Responsive';
// import Monitor from "../../windows/DeskViews/Monitor";
// import { TouchPitchHandler } from 'mapbox-gl';
import CommerceInvoiceCalculations from '../../components/CommerceInvoiceCalculations';
import FormViewer from '../../components/FormViewer';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import HttpServices from '../../utils/Http.services';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// import CustomLoader from '../../components/CustomLoader';
import Collapsible from 'react-collapsible';
import SelectInput from '../../components/inputs/SelectInput';
import ActionsBtn from '../../components/partials/ActionsBtn';
import { forEach } from 'mathjs';


export class CartDelivery extends Component {
    state = {
        showCollapse: null,
        active: false,
        selected: 0,
        checkBox: {},
        isLoading: {},
        collapses: {},
        // taxes: [{ _id: 1, title: 'GST/HST', percentage: 7, help: 'This is a test description about this tax' }, { _id: 0, title: 'PST/RST/QST', percentage: 5, help: 'This is a test description about this tax' }],
        // deliveries: [
        //     { name: 'Fast delivery', _id: 1, options: [1, 2], price: 0, description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. At omnis iure magnam facere numquam reprehenderit laboriosam hic culpa. Beatae quaerat odit quia cumque dolor dicta ad aliquid ducimus esse totam.' },
        //     { name: 'Normal delivery', _id: 2, price: 40, description: "This will be delivered as early as February 9, 2024" },
        // ],

        addressHeaders: [

            { type: 'TextInput', key: 'nickname', information: { label: '{{lang}}Address nickname', placeholder: '{{lang}}nickname', required: true } },
            { type: 'TextInput', key: 'name', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: true } },
            { type: 'TextInput', key: 'family', information: { label: '{{lang}}family', placeholder: '{{lang}}family', required: true } },
            { type: 'PhoneInput', key: 'phone', information: { label: '{{lang}}Phone number', placeholder: '{{lang}}Phone number', required: true } },
            { type: 'AddressInput', key: 'address', information: { required: true } },
            { type: 'SwitchInput', key: 'isDefault', information: { label: '{{lang}}Consider as default address', required: false } },

            // { type: 'SelectInput', key: 'country', information: { label: '{{lang}}Country', address: 'getCountries', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Country', required: true }, showMain: true },
            // { type: 'TextInput', key: 'postalCode', information: { label: '{{lang}}Postal Code', placeholder: '{{lang}}Postal Code', required: true } },

            // { type: 'TextInput', key: 'address', information: { label: '{{lang}}Address', placeholder: '{{lang}}Address', required: true } },
            // { type: 'TextInput', key: 'city', information: { label: '{{lang}}City', placeholder: '{{lang}}City', required: true } },
            // { type: 'TextInput', key: 'province', information: { label: '{{lang}}Province', placeholder: '{{lang}}Province', required: true } },

        ],
        // show: false,

        // product: [
        //     { name: 'Nouveau', title: 'AirPods Pro (2ᵉ génération)', price: '299,00', src: '/images/product/photo1.jfif' },
        //     { name: 'Nouveau', title: 'Coque en cuir avec MagSafe pour iPhone 14 Pro Max - Vert forêt', price: '299,00', src: '/images/product/photo2.jfif' },
        //     { name: 'Nouveau', title: 'Apple TV 4K Wi‑Fi + Ethernet avec 128 Go de stockage', price: '299,00', src: '/images/product/photo3.jfif' },
        //     { name: 'Nouveau', title: 'HomePod mini - Gris sidéral', price: '299,00', src: '/images/product/photo4.jfif' },
        //     { name: 'Nouveau', title: 'Lanière AirTag - Rose agrume', price: '299,00', src: '/images/product/photo5.jfif' },
        // ],
        // filter: [
        //     { name: 'Categories' },
        //     { name: 'Brand' },
        //     { name: 'Price' },
        // ],
        // option: [
        //     { name: "Discounts and offers", src: '/assets/icons/target.svg' },
        //     { name: "best sellers", src: '/assets/icons/flame.svg' },
        //     { name: "amazing", src: '/assets/icons/chart.svg' },
        // ],
        type: [
            { name: "{{lang}}No items saved for later", des: "{{lang}}" },
            { name: "{{lang}}Buy it again", des: "{{lang}}No items to Buy again" },
        ],

        // colors: { color: "white" },

        weeks: [
            { week: "Sunday", date: "18", t1: "5 pm to 6 pm", t2: "4 pm to 6 pm", t3: "19 to 21", },
            { week: "Monday", date: "19", t1: "13 to 16", t2: "15 to 17", t3: "19 to 21", },
            { week: "Tuesday", date: "20", t1: "12 to 16", t2: "17 to 18", t3: "19 to 21", },
            { week: "Wednesday", date: "21", t1: "15 to 19", t2: "06 to 08", t3: "19 to 21", },
            { week: "Thursday", date: "22", t1: "15 to 17", t2: "17 to 19", t3: "19 to 21", },
            { week: "Friday", date: "23", t1: "15 to 17", t2: "17 to 19", t3: "19 to 21", },
            { week: "Saturday", date: "24", t1: "15 to 17", t2: "17 to 19", t3: "19 to 21", },
        ],

        shippingTime: { time: "Sunday 2 january 4pm until 6pm" },
        // prices: [
        //     { price: "$250" },

        // ],

        // shippingPrice: [
        //     { price: "free" },
        // ],

        // totalPrice: { price: "$250" },

        // products: [
        //     { name: '{{lang}}airpod pro 2nd generation', colort: "White", colorb: "#fff", image: "/images/productbuy.png" }
        // ],

        // voucher: [
        //     { type: "{{lang}}Gift Card Code" },
        //     { type: "{{lang}}Discount Voucher" },
        //     // { type: "{{lang}}" },
        //     { type: "{{lang}}Gift Card" },
        //     // { type: "{{lang}}Gift Card" },
        // ],

        // prices: [
        //     { price: "$250", title: 'tax', code: '0' },
        //     { price: "$250", title: 'Subtotal', code: '0' },
        //     { price: "Free", title: 'Shipment Cost', code: '0' },
        //     { price: "-$12", title: 'Discount', code: '1' },

        // ],
        // voucherError: { error: "{{lang}}This code has been used before" },

        // voucherAccept: { accept: "{{lang}}This code has successfully redeemed" },

        addresses: [],
        // { nickname: "Home", address: "4555 Hopyard Rd", city: "Pleasanton", zipcode: "94588", phonenumber: "+1 (345) 454-5554", name: "Hossein Mohseni", },
        // { nickname: "Work", address: "6160 Chambersburg Rd", city: "Atlanta", zipcode: "30338", phonenumber: "+1 (345) 454-5554", name: "Hossein Mohseni", },
        // { nickname: "Mom's House", address: "827 Lincolnway E", city: "Chicago", zipcode: "34553", phonenumber: "+1 (345) 454-5554", name: "Ellena Mohseni", },
        // { nickname: "Office", address: "893 Smithfield Ave", city: "Pleasanton", zipcode: "83246", phonenumber: "+1 (345) 454-5554", name: "Hossein Mohseni", },


        // deliveryType: [
        //     { title: "{{lang}}Normal Shipping" },
        //     { title: "{{lang}}Express Shipping" },
        //     { title: "{{lang}}Pick up at Store" },
        // ],

        // paymentType: [
        //     { title: "{{lang}}Credit Card" },
        //     { title: "{{lang}}Crypto" },
        //     { title: "{{lang}}Digital Wallet" },
        // ],

        // creditCard: [
        //     { name: "{{lang}}Paypal", icon: "/assets/icons/payments/paypal.svg" },
        //     { name: "{{lang}}Visa Card", icon: "/assets/icons/payments/visa.svg" },
        //     { name: "{{lang}}Master Card", icon: "/assets/icons/payments/master.svg" },
        //     { name: "{{lang}}Bancontact", icon: "/assets/icons/payments/bancontact.svg" },

        // ],

    }

    // showNotifications = () => {

    // }

    openSidebar = () => {
        this.sidebarView.openSidebar()
    }
    // handleCollapse = (index) => {
    //     if (this.state.showCollapse == index) {
    //         this.setState({ active: !this.state.active })
    //     } else {
    //         this.setState({ showCollapse: index, active: true })
    //     }
    // }
    componentDidMount() {
        this.setState({ currentIndex: 0, currentItem: this.state.type[0] })
        this.fetchAddresses()
    }


    openAddressForm = (data, index) => {
        this.setState({ currentAddressForEdit: data, currentIndex: index }, () => {
            // console.log(data)
            this.addressFormSide.open()

        })
    }


    fetchAddresses = () => {

        HttpServices.request('getAddresses', {}, (fetchResult, fetchError, fetchStatus) => {

            if (fetchError || !Array.isArray(fetchResult.info)) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }

            let selectedAddress

            let appletId = this.props.variables?.appletId ?? this.props.applet?._id
            let cart = this.props.carts?.applets[appletId]

            fetchResult.info.forEach(address => {
                if (cart.address) {
                    let addressId = typeof cart.address == 'object' ? cart.address._id : cart.address
                    if (address._id == addressId) {
                        selectedAddress = address
                    }
                } else {
                    if (address.isDefault) {
                        selectedAddress = address
                    }
                }
            });

            this.setState({ addresses: fetchResult.info, selectedAddress }, () => {
                let cart = this.props.carts?.applets[appletId]

                if (cart?.fulfillmentInfo) {
                    this.getValidFulfillments()
                } else {
                    this.updateCartAddress()
                }
            })



        })

    }



    submitAddress = () => {
        let body = this.addressForm.getForm()
        if (body) {

            HttpServices.request('postAddress', body, (fetchResult, fetchError, fetchStatus) => {

                if (fetchError || !fetchResult.info) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                    return
                }
                let addresses = this.state.addresses ?? []

                if (this.state.currentAddressForEdit?._id) {
                    addresses[this.state.currentIndex] = fetchResult.info
                } else {
                    addresses.splice(0, 0, fetchResult.info)
                }

                this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postSuccesfully', description: '{{lang}}Address updated successfully' })
                this.addressFormSide.close()
                this.setState({ addresses, selectedAddress: fetchResult.info }, () => {


                })



            })
        }
    }

    getValidFulfillments = () => {

        // console.log("getValidFulfillments")

        let appletId = this.props.variables?.appletId ?? this.props.applet?._id
        let cart = this.props.carts?.applets[appletId]

        let body = {
            address: this.state.selectedAddress?._id,
            cart: cart?._id
        }

        HttpServices.request('getValidFulfillments', body, (fetchResult, fetchError, fetchStatus) => {

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.updateFailed', description: checkTranslation(fetchError.message) })
                return
            }

            console.log(fetchResult)

            this.createFulfullmentGroups(cart.fulfillmentInfo, fetchResult.validFulfillments, fetchResult.itemsFulfillments, cart.items, cart.fulfillmentInfo.leftOverItems)

            // console.log(cart.fulfillmentInfo)

            this.setState({ activeFulfillment: cart.fulfillmentInfo })

        })

    }


    updateCartAddress = () => {

        let appletId =this.props.variables?.appletId ?? this.props.applet?._id 
        let cart = this.props.carts?.applets[appletId]
        let body = {
            address: this.state.selectedAddress?._id,
            cart: cart?._id
        }
        this.setState({ isLoadingFulfillment: true })

        HttpServices.request('updateCartAddress', body, (fetchResult, fetchError, fetchStatus) => {

            // console.log(fetchResult)
            this.setState({ isLoadingFulfillment: false })

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.updateFailed', description: checkTranslation(fetchError.message) })
                return
            }

            let fulfillmentInfo = fetchResult.info?.fulfillmentInfo
            // let taxInfo = fetchResult?.taxInfo
            let items = fetchResult.info?.items

            let needsDeliveryInfo = false

            if (Array.isArray(items)) {
                items.forEach(item => {
                    if (Array.isArray(item.product?.fulfillments) && item.product?.fulfillments.length > 0) {
                        needsDeliveryInfo = true
                    }
                });

                // console.log(fetchResult)

                this.createFulfullmentGroups(fulfillmentInfo, fetchResult.validFulfillments, fetchResult.itemsFulfillments, items, fulfillmentInfo?.leftOverItems)

                this.props.actions.setCart(fetchResult.info)

                this.setState({ activeFulfillment: fulfillmentInfo, needsDeliveryInfo })
            }
        })

    }


    changeActiveFulfillment = (itemsFulfillments) => {

        let appletId = this.props.variables?.appletId ?? this.props.applet?._id 
        let cart = this.props.carts?.applets[appletId]

        let body = {
            cart: cart?._id,
            itemsFulfillments,
            address: this.state.selectedAddress?._id,
        }

        this.setState({ isLoadingFulfillment: true })

        HttpServices.request('changeItemsFulfillment', body, (fetchResult, fetchError, fetchStatus) => {

            this.setState({ isLoadingFulfillment: false })

            if (fetchError) {

                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.updateFailed', description: checkTranslation(fetchError.message) })
                return

            }

            let items = cart.items


            let fulfillmentInfo = fetchResult.info?.fulfillmentInfo



            this.createFulfullmentGroups(fulfillmentInfo, fetchResult.validFulfillments, fetchResult.itemsFulfillments, items, fulfillmentInfo.leftOverItems)

            this.props.actions.setCart(fetchResult.info)

            this.setState({ activeFulfillment: fulfillmentInfo })



        })
    }





    createFulfullmentGroups(activeFulfillment, fulfillmentsList, itemsFulfillments, items, leftOverItems) {

        let fulfilmentGroups = []
        let itemsFulfilmentsRelation = {}
        let leftOverGroup


        console.log("activeFulfillment", activeFulfillment)
        console.log("fulfillmentsList", fulfillmentsList)
        console.log("itemsFulfillments", itemsFulfillments)



        items.forEach(item => {

            if (itemsFulfillments && Array.isArray(itemsFulfillments[item._id])) {

                itemsFulfillments[item._id].forEach(itemsFulfillment => {

                    fulfillmentsList.forEach(fulfillment => {
                        if (fulfillment._id == itemsFulfillment) {
                            if (!itemsFulfilmentsRelation[item._id]) {
                                itemsFulfilmentsRelation[item._id] = []
                            }
                            let selectValue = { _id: fulfillment._id, value: fulfillment._id, title: fulfillment.name }
                            itemsFulfilmentsRelation[item._id].push(selectValue)
                        }
                    });

                });



            }
        });

        // console.log("leftOverItems")
        // console.log(leftOverItems)

        leftOverGroup = {
            items: [],
            fulfillment: {
                name: translate('Following items are not in an valid fulfillment group. You need to move them to a filfillment group.'),
                description: translate('If there is no fulfillment available for any of the items, You can not proceed. You may need to contact the hub support for further assitant.'),
            }
        }


        if (Array.isArray(leftOverItems) && leftOverItems.length > 0) {


            leftOverItems.forEach(item => {
                items.forEach(rawItem => {
                    if (item == rawItem._id) {

                        leftOverGroup.items.push(rawItem)
                    }

                });

            });


        }

        // console.log("activeFulfillment?.groups",activeFulfillment?.groups)

        if (Array.isArray(activeFulfillment?.groups) && Array.isArray(fulfillmentsList)) {


            activeFulfillment?.groups.forEach((group, index) => {

                let groupId = typeof group.fulfillment == 'object' ? group.fulfillment?._id : group.fulfillment
                let newGroup = { items: [], amounts: group.amounts }


                fulfillmentsList.forEach(rawFulfillment => {

                    if (rawFulfillment._id == groupId) {
                        newGroup.fulfillment = rawFulfillment
                    }
                })

                if (Array.isArray(group.items)) {


                    group.items.forEach(item => {

                        items.forEach(rawItem => {
                            if (rawItem._id == item) {

                                newGroup.items.push(rawItem)

                            }
                        })

                    })
                }

                if (!newGroup.fulfillment && newGroup.items.length > 0) {

                    newGroup.items.forEach(rawItem => {

                        leftOverGroup.items.push(rawItem)


                    });
                }

                if (newGroup.fulfillment && newGroup.items.length > 0) {

                    let posibilities = {}

                    // console.log("TP0")

                    fulfillmentsList.forEach(rawFulfillment => {


                        if (rawFulfillment._id != groupId) {


                            let newPosibility = { items: [], id: rawFulfillment._id, fulfillment: rawFulfillment }

                            group.items.forEach(item => {


                                if (itemsFulfillments[item] && itemsFulfillments[item].includes(rawFulfillment._id)) {
                                    newPosibility.items.push(item)

                                }
                            })

                            if (newPosibility.items.length > 0) {
                                posibilities[newPosibility.id] = newPosibility
                            }
                        }

                    });



                    // if (Array.isArray(validPosibilities)) {

                    //     validPosibilities.forEach(validPosibility => {


                    //         validPosibility.groups.forEach(pGroup => {


                    //             pGroup.items.forEach(pItem => {

                    //                 if (!itemsFulfilmentsRelation[pItem]) {
                    //                     itemsFulfilmentsRelation[pItem] = []
                    //                 }

                    //                 if (!this.getObjectFromArray(itemsFulfilmentsRelation[pItem], pGroup.fulfillment, '_id')) {
                    //                     let selectValue = this.getObjectFromArray(fulfillmentsList, pGroup.fulfillment, '_id')
                    //                     selectValue = { _id: selectValue._id, value: selectValue._id, title: selectValue.name }
                    //                     itemsFulfilmentsRelation[pItem].push(selectValue)
                    //                 }
                    //             });


                    //             if (validPosibility.info?.isValid && Array.isArray(validPosibility.groups)) {


                    //                 if (pGroup.fulfillment != group.fulfillment && Array.isArray(pGroup.items)) {

                    //                     let newPosibility = { items: [], id: pGroup.fulfillment, fulfillment: this.getObjectFromArray(fulfillmentsList, pGroup.fulfillment, '_id') }

                    //                     group.items.forEach(item => {
                    //                         pGroup.items.forEach(pItem => {

                    //                             if (pItem == item) {

                    //                                 newPosibility.items.push(pItem)

                    //                             }
                    //                         })

                    //                     })

                    //                     if (newPosibility.items.length > 0) {
                    //                         if (!posibilities[newPosibility.id]) {
                    //                             posibilities[newPosibility.id] = newPosibility
                    //                         } else {
                    //                             newPosibility.items.forEach(pppitem => {
                    //                                 let found = false
                    //                                 posibilities[newPosibility.id].items.forEach(ppitem => {
                    //                                     if (pppitem == ppitem) {
                    //                                         found = true
                    //                                     }
                    //                                 });

                    //                                 if (!found) {
                    //                                     posibilities[newPosibility.id].items.push(pppitem)
                    //                                 }
                    //                             });
                    //                         }
                    //                         // console.log(posibilities[newPosibility.id].items.sort().join(','))
                    //                         // console.log(group.items.sort().join(','))
                    //                         if (posibilities[newPosibility.id].items.sort().join(',') == group.items.sort().join(',')) {
                    //                             posibilities[newPosibility.id].sameItems = true
                    //                         }
                    //                     }


                    //                 }

                    //             }
                    //         })

                    //     })

                    // }

                    if (Object.values(posibilities).length > 0) {
                        newGroup.posibilities = Object.values(posibilities)
                    }


                    fulfilmentGroups.push(newGroup)
                }
            })



            // TO DO: LEFT OVER ITEMS
        }

        // console.log(leftOverGroup)

        if (leftOverGroup.items.length == 0) {
            leftOverGroup = null
        }

        console.log(itemsFulfilmentsRelation)
        // return
        this.setState({ fulfilmentGroups, leftOverGroup, itemsFulfilmentsRelation })

    }


    getObjectFromArray(array, value, key) {

        let result
        array.forEach(element => {
            let mValue = getObject(element, key)
            if (mValue == value) {
                result = element
            }
        });
        return result
    }


    addressChanged = () => {
        let selectedAddress = this.state.selectedAddress
        if (selectedAddress) {
            this.updateCartAddress()
        }
    }





    changeCollapse = (index) => {
        let collapses = this.state.collapses ?? {}
        collapses[index] = !collapses[index]
        this.setState({ collapses })
    }


    changeItemsFulfillment = (ids, to) => {
        let activeFulfillment = this.state.activeFulfillment

        // console.log("activeFulfillment", activeFulfillment)

        let itemsFulfillments = []

        if (activeFulfillment && Array.isArray(activeFulfillment.groups)) {

            activeFulfillment.groups.forEach(group => {

                group.items.forEach((item, index) => {

                    if (ids.includes(item)) {
                        itemsFulfillments.push({ item: item, fulfillment: to })
                    } else {
                        let groupId = typeof group.fulfillment == 'object' ? group.fulfillment?._id : group.fulfillment
                        itemsFulfillments.push({ item: item, fulfillment: groupId })

                    }

                })

            })
        } else {

            ids.forEach(id => {
                itemsFulfillments.push({ item: id, fulfillment: to })
            });

        }

        // console.log("itemsFulfillments", itemsFulfillments)
        // return
        // console.log()
        this.changeActiveFulfillment(itemsFulfillments)

        // console.log("itemsFulfillments", itemsFulfillments)



    }





    renderGroup(group, gIndex, isLeftOverGroup) {
        // console.log("group",group)
        return (
            <div className=' mb-4 p-3 br-10 ' style={{ backgroundColor: "#fff" }}>

                <div className='pb-3' style={{ borderBottom: '1px solid #eee' }}>

                    {Array.isArray(group.posibilities) && group.posibilities.map((posibility, index) => {
                        return (
                            <div className='pb-3 w-100 mb-2 pt-1' style={{ borderBottom: "1px solid #f6f6f6" }} >

                                {/* {posibility.sameItems ? ( */}
                                <button className='flexc w-100' onClick={() => this.changeItemsFulfillment(posibility.items, posibility.fulfillment?._id)}>
                                    <label className="checkbox-container " >
                                        <input type="checkbox" checked={!this.state.checkBox} />
                                        <span className="radioMark"></span>
                                    </label>
                                    {posibility.sameItems ? (
                                        <div className='flexc'>
                                            <p className='font-size-18 title-color pld-2 text-bold'>{checkTranslation(posibility?.fulfillment?.name)} </p>
                                            <span className='text-smaller text-semibold br-20 px-2 py-1 mld-2' style={{ background: '#eee', color: '#444' }} >Can be used for all items of group </span>
                                        </div>
                                    ) : (
                                        <div className='flexc'>
                                            <p className='font-size-14 title-color pld-2 text-bold'>{checkTranslation(posibility?.fulfillment?.name)} </p>
                                            <span className='text-smaller text-semibold br-20 px-2 py-1 mld-2' style={{ background: '#eee', color: '#444' }} >Can be used for {posibility.items.length} items of this group</span>
                                        </div>
                                    )}

                                </button>
                                {/* ) : (
                            <div className='flexc'>
                                <div className='flexcc'>
                                    <ActionsBtn index={index} actions={this.state.actions} actionClicked={this.actionClicked} currentRecord={this.props.currentRecord} colors={this.props.colors} />
                                </div>
                                <div className='flexc'>
                                    <p className='font-size-14 title-color pld-2 text-bold'>{checkTranslation(posibility?.fulfillment?.name)} </p>
                                    <span className='text-smaller text-semibold br-20 px-2 py-1 mld-2' style={{ background: '#eee', color: '#444' }} >Can be used for {posibility.items.length} items of this group</span>
                                </div>
                            </div>
                        )} */}

                                {posibility?.fulfillment?.description && (
                                    <div className='mt-1'>
                                        <p className='font-size-12 des-color  pld-2 mt-1'>{checkTranslation(posibility?.fulfillment?.description)}</p>
                                    </div>
                                )}
                            </div>
                        )
                    })}

                    <div className='d-flex justify-content-between'>


                        <div className='pt-1'>

                            {Array.isArray(group.posibilities) && group.posibilities.length > 0 ? (
                                <button className='flexc pb-2 w-100' >
                                    <label className="checkbox-container " >
                                        <input type="checkbox" checked={true} />
                                        <span className="radioMark"></span>
                                    </label>

                                    <p className='font-size-18 title-color pld-2 text-bold'>{checkTranslation(group?.fulfillment?.name)}</p>

                                </button>
                            ) : (
                                <p className='font-size-18 title-color pld-2 text-bold'>{checkTranslation(group?.fulfillment?.name)}</p>
                            )}

                            {!isLeftOverGroup && (

                                <p className='font-size-12 des-color text-semibold pld-2 mt-1'> <span className='font-size-12 '>{`Shipment ${gIndex + 1} of ${this.state.fulfilmentGroups.length}`}</span> - {group.items?.length}{translate(' items')}</p>
                            )}
                        </div>

                        {!isLeftOverGroup && (

                            <div>
                                {(group.amounts?.final > 0 || (group.amounts?.base != group.amounts?.final)) ? (
                                    <div>
                                        <p className='font-size-18 weight-700  '>Cost {group.amounts?.base != group.amounts?.final && (<span className='text-smaller' style={{ color: "#777", textDecoration: 'line-through' }}>${priceStandardView(group.amounts?.base)}</span>)} ${priceStandardView(group.amounts?.final)}</p>
                                    </div>
                                ) : (
                                    <div>
                                        <p className='font-size-18 weight-700  '>{translate("Free")}</p>
                                    </div>
                                )}

                            </div>
                        )}
                    </div>

                    <p className='font-size-13 des-color  pld-2 mt-2'>{group.fulfillment.description}</p>
                </div>

                <button className='mt-3 px-1' onClick={() => this.changeCollapse(gIndex)}>
                    {this.state.collapses[gIndex] ? (
                        <p className='text-link'>{translate("Show items list")}</p>
                    ) : (
                        <p className='text-link'>{translate("Hide items list")}</p>
                    )}
                </button>
                <Collapsible open={!this.state.collapses[gIndex]} transitionTime={50}>
                    <div className='mt-3'>
                        {Array.isArray(group.items) && group.items?.map((props, iIndex) => {

                            return this.renderItem(group, props, iIndex, isLeftOverGroup)
                        })}
                    </div>
                </Collapsible>

                {group.fulfillment?.type == 'schedule' && (
                    this.renderSchedule(group)

                )}
                {/* <div className='m-1 mt-4 pb-3' style={{ borderBottom: "1px solid #ddd" }}>
                        <p className='font-size-16 title-color'>{translate('Voucher')}</p>
                        <p className='font-size-13 des-color'>{translate('Select the the voucher type blow')}</p>
                        <div className='mt-3'>
                            <input className='font-size-14 title-color py-2 br-30 input-buy change-placeHolder px-3' placeholder={translate('Redeem Code')} />
                            <button className='buy-btn px-4 py-2 br-30 mld-3' style={{ background: background ?? '#007aff' }}>
                                <p className='font-size-14'>{translate('Submit')}</p>
                            </button>
                            <p className='font-size-12 error-text mt-2'>{checkTranslation(this.state.voucherError.error)}</p>
                            <p className='font-size-12 accept-text mt-2'>{checkTranslation(this.state.voucherAccept.accept)}</p>
                        </div>
                    </div> */}
                {/* <div className='m-1 mt-4'>
                    <p className='font-size-16 title-color'>{translate('Payment')}</p>
                    <p className='font-size-13 des-color'>{translate('Choose the Payment Type')}</p>
                </div> */}

                {/* <div className='flexcb mt-3'>
                    {this.state.paymentType.map((prop, index) => {
                        return (
                            <div className='w-100 mx-2'>
                                <button className={`px-4 py-2 br-30 cursor week-btn w-100 ${this.state.currentIndex == index ? 'week-btn-selected' : ''}`} onClick={() => this.setState({ currentItem: prop, currentIndex: index })}>
                                    <p className='font-size-12'>{checkTranslation(prop.title)}</p>
                                </button>
                            </div>
                        )
                    })}
                </div> */}

                {/* <div className='d-flex flex-wrap mt-3'>
                    {this.state.creditCard.map((prop, index) => {
                        return (
                            <Responsive className={'my-2'} width={this.props.width} media={this.props.col ?? { xs: "12", sm: '6', md: '6', lg: "3", xl: "3" }}>
                                <div className='mx-2'>
                                    <button className={`px-4 py-2 br-10 cursor payment-card shadow-hover w-100 ${this.state.currentIndex == index ? 'blue-border ' : 'invisible-border'}`} onClick={() => this.setState({ currentItem: prop, currentIndex: index })}>
                                        <img width={100} src={prop.icon} />
                                        <p>{checkTranslation(prop.name)}</p>
                                    </button>
                                </div>
                            </Responsive>
                        )
                    })}
                </div> */}
            </div>
        )
    }


    renderItem(group, props, iIndex, isLeftOverGroup) {
        let selectItems = this.state.itemsFulfilmentsRelation[props._id]

        return (
            <div key={props._id} className={'d-flex  pb-3 pt-1th-3 bb-gray ' + (this.props.width < 576 ? ' flex-wrap' : '')}>

                <Responsive className={''} width={this.props.width} media={this.props.col ?? { xs: "100%", sm: '150px' }}>

                    <div >
                        <img width={'100%'} className='br-5' style={{ aspectRatio: '1 / 1', objectFit: 'cover', maxWidth: 200 }} src={imageAddress(props.product?.media)} onClick={() => this.changePage('product', ['product', props.product?._id])} alt='' />
                    </div>

                </Responsive>

                <Responsive className={''} width={this.props.width} media={this.props.col ?? { xs: "100%" }}>

                    <div className={' w-100 ' + (this.props.width < 576 ? '' : 'mld-4')}>

                        <button className='mb-1' onClick={() => this.goToProduct(props)}>
                            <p className='font-size-14 weight-500 '>{checkTranslation(props.product?.name)}</p>
                        </button>


                        {props?.variants && (
                            <div className='w-100'>
                                {Object.entries(props?.variants)?.map(([key, value]) => {
                                    return (
                                        <p className='font-size-12 weight-400 main-c7 mld-1 ' style={{ textTransform: 'capitalize', marginTop: 2 }}><span className='font-size-12 weight-400'>{key}:</span> {value}</p>
                                    )
                                })}
                            </div>
                        )}

                        {typeof props?.additionals == 'object' && (
                            <div className='w-100'>
                                {Object.entries(props?.additionals)?.map(([key, value]) => {
                                    return (
                                        <div>
                                            <span className='font-size-12 weight-400 main-c7 mld-1' style={{ textTransform: 'capitalize' }}>{key}:
                                                {typeof value == 'object' && Object.entries(value)?.map(([optionKey, optionValue], oindex) => {
                                                    return (
                                                        <span>
                                                            {optionKey == 'text' ? (
                                                                <span className='font-size-12 weight-400 main-c7 mld-1' style={{ textTransform: 'capitalize' }}> {optionValue?.value}</span>

                                                            ) : (
                                                                <>
                                                                    <span className='font-size-12 weight-400 main-c7 mld-1' style={{ textTransform: 'caspanitalize' }}>{optionKey}
                                                                        {optionValue?.priceDifference && (
                                                                            <span className='font-size-12 weight-400 main-c7 mld-1'>
                                                                                ({(optionValue?.value != true && optionValue?.value > 1) ? (optionValue?.value + "*" + optionValue?.priceDifference) : ("$" + optionValue?.priceDifference)})
                                                                            </span>
                                                                        )}
                                                                    </span>

                                                                </>
                                                            )}
                                                            {(oindex < (Object.entries(value).length - 1)) && (
                                                                <span className='mld-1'>,</span>
                                                            )}
                                                        </span>
                                                    )
                                                })}
                                            </span>
                                        </div>
                                    )
                                })}
                            </div>
                        )}

                        <div className='flexcb w-100 mt-2 prd-3' >
                            <div className=''>
                                <div className='flexc'>
                                    <p className='font-size-14 weight-500  '> ${priceStandardView(props.amounts?.final)}</p>

                                    {(props.amounts?.final != props.amounts?.base) && (
                                        <p className='font-size-12 main-c4 text-lined mld-2'>${priceStandardView(props.amounts?.base)}</p>
                                    )}
                                    {(props?.price?.onSale && !props.amounts?.additionals) && (
                                        <p className='font-size-12 mld-2  px-2 br-30' style={{ color: '#fff', backgroundColor: "rgb(204, 12, 57)" }}>{props.product?.price?.discount?.value}{props.product?.price?.discount?.unit ?? '%'}</p>
                                    )}
                                </div>
                            </div>

                            <div className='px-2'>
                                <p className='text-smaller text-semibold flexc main-c7' style={{ whiteSpace: 'nowrap' }}>{translate("Quantity")} <span className='mld-1'>{props.count}</span></p>
                            </div>
                            {/* <div className='flexcb br-30 p-1 ' style={{ border: '1px solid #eee', backgroundColor: '#f6f6f6' }}>
                    <button onClick={() => this.addToCart('subtract', 1, props, index)} className='br-30'>
                        <img width={20} className='flexcc' style={{ opacity: '.7' }} src='/assets/icons/minimize.svg' />
                    </button>
                    <div className='px-3 position-relative'>
                        {this.state.isLoading[index] && (
                            <div className='w-100 flexcc' style={{ position: 'absolute', top: 6, left: 0 }}>
                                <CustomLoader isLoading={true} type={'ThreeDots'} color={'#444'} height={10} />
                            </div>
                        )}

                        <p className='main-c4 weight-700' style={{ color: this.state.isLoading[index] ? 'transparent' : null }}>{props.count}</p>

                    </div>
                    <button onClick={() => this.addToCart("add", 1, props, index)} className='br-30'>
                        <img width={20} className='flexcc' style={{ opacity: '.7' }} src='/assets/icons/plus.svg' />
                    </button>
                </div> */}
                        </div>

                        {selectItems && ((isLeftOverGroup && selectItems.length > 0) || (!isLeftOverGroup && selectItems.length > 1)) && (
                            <>
                                <div className='bordered-input mt-3 w-80 flex-1' style={{ maxWidth: 300 }}>
                                    <p className='mt-1 text-smaller text-semibold px-1 ' style={{ color: '#777' }}>{translate("Current fulfillment")}</p>
                                    <div className='cursor-pointer'>
                                        <SelectInput data={group.fulfillment?._id} changeValue={(key, value) => this.changeItemsFulfillment([props._id], value)} header={{ key: 'type', information: { items: selectItems, placeholder: '{{lang}}Select ...', required: true }, required: true }} />
                                    </div>
                                </div>
                            </>
                        )}


                    </div>

                </Responsive>
            </div>
        )

    }


    renderSchedule(group) {
        return (
            <div className='px-1 mt-3 pb-3 pt-2' style={{ borderTop: "1px solid #eee" }}>

                {/* <div className=''>
                <div className='my-3'>
                    <p className='mld-2 font-size-14 title-color'>{translate('Choose the Shipping method')}</p>
                </div>
                <div className='flexcb'>
                    {this.state.deliveryType.map((prop, index) => {
                        return (
                            <div className=''>
                                <button style={{ background: this.state.currentIndex === index ? background : '#f6f6f6' }} className={`px-4 py-2 br-30 cursor week-btn w-100 ${this.state.currentIndex == index ? 'week-btn-selected' : ''}`} onClick={() => this.setState({ currentItem: prop, currentIndex: index })}>
                                    <p className='font-size-12'>{checkTranslation(prop.title)}</p>
                                </button>
                            </div>
                        )
                    })}
                </div>
            </div> */}

                <div className='flexc mb-3  mt-2'>
                    {/* <img width={15} src='/assets/icons/time.svg' /> */}
                    <p className=' font-size-16  text-semibold'>{checkTranslation('Choose the delivery time')}</p>
                </div>
                <div className='flexc pb-2 sc-3' style={{ overflowX: "auto" }}>
                    {this.state.weeks.map((props, index) => {
                        return (
                            <div className='mrd-5'>
                                <button className={`px-0 pb-2 cursor week-btn w-100 text-start ${this.state.currentIndex == index ? 'week-btn-selected' : ''}`} onClick={() => this.setState({ currentItem: props, currentIndex: index })}>
                                    <p className='font-size-18 text-semibold pt-0'>{props.date}</p>
                                    <p className='font-size-12'>{checkTranslation(props.week)}</p>
                                </button>
                            </div>
                        )
                    })}
                </div>
                <div className='d-flex flex-column'>
                    <button className='flexc py-3' style={{ borderBottom: "1px solid #f6f6f6" }} onClick={() => this.setState({ checkBox: !this.state.checkBox })}>
                        <label className="checkbox-container " >
                            <input type="checkbox" checked={!this.state.checkBox} />
                            <span className="radioMark"></span>
                        </label>
                        <p className='font-size-14 mld-3 title-color text-semibold'>From 9am to 12pm</p>
                    </button>
                    <button className='flexc py-3' style={{ borderBottom: "1px solid #f6f6f6" }} onClick={() => this.setState({ checkBox: !this.state.checkBox })}>
                        <label className="checkbox-container " >
                            <input type="checkbox" checked={!this.state.checkBox} />
                            <span className="radioMark"></span>
                        </label>
                        <p className='font-size-14 mld-3 title-color text-semibold'>From 9am to 12pm</p>
                    </button>
                </div>
                {/* <div className='flexc pt-2 mb-3'>
                <p className='font-size-14 title-color'>{translate('Shipping Time')}</p>
                <p className='font-size-14 title-color mld-3'>{checkTranslation(this.state.shippingTime.time)}</p>
            </div> */}
            </div>
        )
    }

    continue() {

        let activeFulfillment = this.state.activeFulfillment

        // console.log(activeFulfillment)
        // console.log(activeFulfillment?.leftOverItems)
        let appletId = this.props.variables?.appletId ?? this.props.applet?._id
        let cart = this.props.carts?.applets[appletId]

        // console.log(cart)


        if (this.state.needsDeliveryInfo && (!activeFulfillment || (activeFulfillment.leftOverItems && Array.isArray(activeFulfillment.leftOverItems) && activeFulfillment.leftOverItems.length > 0))) {

            this.props.actions.addNotif({ type: 'error', title: '{{lang}}There are some left over items.', description: "{{lang}}Fulfillment option is not selected for some of items in the list." })
            return
        }

        // console.log(this.state.selectedAddress)
        // console.log(this.state.activeFulfillment)

        if (!this.state.needsDeliveryInfo || (this.state.activeFulfillment && this.state.selectedAddress)) {
            this.props.changeStage("payment")
        } else {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}Check fulfillment info', description: "{{lang}}Fulfillment is not valid. please check the information again." })
        }
    }



    render() {
        let colors = this.props.colors
        let background = `linear-gradient(90deg, ${colors?.primaryColor}, ${colors?.secondaryColor})`
        // let type = this.state.type
        let selectedAddress = this.state.selectedAddress

        let cart = {}
        if (this.props.carts?.applets) {
            let appletId = this.props.variables?.appletId ?? this.props.applet?._id
            cart = this.props.carts?.applets[appletId]
        }

        return (
            <div className='w-100 window-content-radius h-100 d-flex flex-column scroll-no-scrollbar' style={{ background: "#f6f6f6" }}>

                {/* <div>
                    <div>
                        <div className='p-4 m-3 br-10' style={{ backgroundColor: "#f6f6f6" }}>
                            <div className='d-flex' style={{ maxWidth: "700px" }}>
                                <div className=' mrd-5'>
                                    <img width={50} src='/assets/icons/applets/commerce/emptycart.svg' />
                                </div>
                                <div className=''>
                                    <p className='font-size-18 weight-500'>Your Yonnect Cart is empty.</p>
                                    <p className='font-size-12 pt-1' style={{ color: "#696969" }}>Your Shopping Cart lives to serve. Give it purpose — fill it with groceries, clothing, household supplies, electronics, and more. Continue shopping on the <a className='text-link' href='/'>Yonnect.com</a> homepage, learn about <a className='text-link' href='/'>today's deals </a>, or visit your <a className='text-link' href='/'>Wish List.</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className='p-3'>
                            <p className='font-size-10'>The price and availability of items at Yonnect.com are subject to change. The Cart is a temporary place to store a list of your items and reflects each item's most recent price.<a className='text-link' href='/'> learn more. </a></p>
                            <p className='font-size-10 pt-3'>Shopping CartLearn more Do you have a gift card or promotional code? We'll ask you to enter your claim code when it's time to pay.</p>
                        </div>
                    </div>
                </div> */}
                {/* <div className='px-4 br-10 py-3 flexcb bg-white  '>

                    <p className='text-bold  text-semibig'>Shopping cart</p>

                    <div className='flexc w-100'>

                        <button className='mld-5 mrd-5 flexc commerce-progress-b' >
                            <img className='mrd-2' width={22} src='/assets/icons/commerce/cart-commerce-b.svg' />
                            <p className='font-size-14 ' style={{ whiteSpace: "nowrap" }}>{translate('Your cart')}</p>
                        </button>

                        <img width={15} src='/assets/icons/arrow-right-black.svg' />

                        <button className='mld-5 mrd-5 flexc commerce-progress-a'>
                            <img className='mrd-2' width={22} src='/assets/icons/commerce/truck-commerce.svg' />
                            <p className='font-size-14' style={{ whiteSpace: "nowrap" }}>{translate('Time and Delivery')}</p>
                        </button>

                        <img width={15} style={{ opacity: ".5" }} src='/assets/icons/arrow-right-black.svg' />

                        <button className='mld-5 mrd-5 flexc commerce-progress'>
                            <img className='mrd-2' width={22} src='/assets/icons/commerce/pay-commerce.svg' />
                            <p className='font-size-14' style={{ whiteSpace: "nowrap" }}>{translate('Payment')}</p>
                        </button>

                    </div>
                </div> */}
                <div className='d-flex flex-wrap mt-3'>
                    <Responsive className={''} width={this.props.width} media={this.props.col ?? { xs: "12", sm: '12', md: '8', lg: "8", xl: "9" }}>
                        <div className='mx-3 mb-2'>


                            <div className='px-4 br-10 py-3 flexcb bg-white  '>
                                {this.state.needsDeliveryInfo && (
                                    <p className='text-bold  text-semibig'>{translate('Order Delivery')}</p>
                                )}

                                {!this.state.needsDeliveryInfo && (
                                    <p className='text-bold  text-semibig'>{translate('Billing information')}</p>
                                )}
                            </div>

                            <div className=' mb-3 mt-3 px-4 py-3 br-10 ' style={{ backgroundColor: "#fff" }}>
                                <div className='flexc'>
                                    <img className='mrd-2' width={15} src='/assets/icons/address-location.svg' />
                                    {this.state.needsDeliveryInfo && (
                                        <p className='font-size-16 text-bold '>{translate('Delivery Address')}</p>
                                    )}

                                    {!this.state.needsDeliveryInfo && (
                                        <p className='font-size-16 text-bold '>{translate('Billing Address')}</p>
                                    )}

                                </div>

                                {selectedAddress ? (
                                    <div className={'d-flex  py-2 ' + ((this.props.width < 576 ? ' flex-column ' : ' justify-content-between align-items-end '))}>

                                        <div>


                                            {/* <img className='mrd-2' width={15} src='/assets/icons/address-location.svg' /> */}
                                            <p className='font-size-14 mb-1'><span className='text-bold'>{selectedAddress.nickname}</span> - {selectedAddress.name} {selectedAddress.family}</p>
                                            <p className='font-size-14 '>{selectedAddress.address}</p>
                                            {selectedAddress.address2 && (
                                                <p className='font-size-14 '>{selectedAddress.address2}</p>
                                            )}
                                            <p className='font-size-14 '>{selectedAddress?.city}, {selectedAddress?.state?.name}, {selectedAddress?.country?.iso2}</p>
                                            <p className='font-size-14 mt-1'>{phoneStandardView(selectedAddress?.phone)}</p>

                                        </div>

                                        <button onClick={() => this.openSidebar()} className={'flexc ' + (this.props.width < 576 ? ' mt-2 ' : '')}>
                                            <p className='text-link mrd-2'>{translate("Change Address")}</p>
                                            <img width={15} src='/assets/icons/arrow-link.svg' />
                                        </button>
                                    </div>
                                ) : (
                                    <div className='pt-3 pb-3'>
                                        <p className='text-normal text-semibold mb-1'>{translate("No address is selected.")}</p>
                                        <p className='text-small text-semibold mb-2'>{translate("Please select an address to proceed.")}</p>

                                        <button onClick={() => this.openSidebar()} className='flexc'>

                                            <p className='text-link mrd-2'>Select Address</p>
                                            <img width={15} src='/assets/icons/arrow-link.svg' />
                                        </button>
                                    </div>
                                )}
                            </div>

                            {Array.isArray(this.state.fulfilmentGroups) && this.state.fulfilmentGroups.map((group, gIndex) => {
                                return (this.renderGroup(group, gIndex))
                            })}


                            {this.state.leftOverGroup && (

                                this.renderGroup(this.state.leftOverGroup, null, true)
                            )}

                        </div>
                    </Responsive>


                    <Responsive className='flex-1' width={this.props.width} media={this.props.col ?? { xs: "12", sm: '12', md: '4', lg: "4", xl: "3" }}>
                        {/* <div className='mrd-5 mt-3 p-3 br-10  position-sticky top-0' style={{ backgroundColor: "#fff" }}>
                            <div className='pb-3 mx-1' style={{ borderBottom: "1px solid #ddd" }}>

                                {this.state.prices.map((props, index) => {
                                    return (
                                        <div className='flexcb '>
                                            <p>{translate('Product Price')}</p>
                                            <p>{checkTranslation(props.price)}</p>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className='py-3 mx-1' style={{ borderBottom: "1px solid #ddd" }}>
                                {this.state.shippingPrice.map((props, index) => {
                                    return (
                                        <div className='flexcb'>
                                            <div>
                                                <p>{translate('Shipping Cost')}</p>
                                                <p className='text-link font-size-10 mt-1'>{translate('Learn more')}</p>
                                            </div>
                                            <div className='flexc'>
                                                <p className='font-size-14' >{checkTranslation(props.price)}</p>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                            <div className='py-3 mx-1 flexcb' style={{ borderBottom: "1px solid #ddd" }}>
                                <p>{translate('Total payment')}</p>
                                <p>{checkTranslation(this.state.totalPrice.price)}</p>
                            </div>
                            <div className='pt-3 mx-1 d-flex justify-content-center'>
                                <button className='buy-btn w-100 br-10 px-5 py-2' onClick={() => this.props.changeStage("payment")}>
                                    <p className='font-size-14'>{translate('Check out')}</p>
                                </button>
                            </div>
                        </div> */}
                        <div className='mrd-5 p-3 br-10 position-sticky  ' style={{ backgroundColor: "#fff", top: 15 }}>

                            <CommerceInvoiceCalculations variables={this.props.variables} taxes={this.state.taxes} taxInfo={this.state.taxInfo} fulfillmentInfo={this.state.fulfillmentInfo} applet={this.props.applet} />

                            <div className='d-flex my-2'>
                                {/* <div>
                                    <img width={28} src='/assets/icons/exclamationmark.circle.fill.svg' />
                                </div> */}
                                <p className='font-size-12 '>By Continuing this step you will accept the price of paying in the next step plus shipping time.</p>
                            </div>
                            <div className=' d-flex justify-content-center mt-3'>
                                <button className='br-8 px-5 py-2 w-100' style={{ background: background ?? '#007aff' }} onClick={() => this.continue()}>
                                    <p className='font-size-14 white text-semibold py-1'>{translate('Continue')}</p>
                                </button>
                            </div>

                            <div className=' d-flex justify-content-center mt-1'>
                                <button className='br-30 px-5 py-2 w-100' style={{}} onClick={() => this.props.changeStage("cart")}>
                                    <p className='font-size-14 '>{translate('Previous page')}</p>
                                </button>
                            </div>
                        </div>
                    </Responsive>
                </div>



                <SidebarView onClosed={() => this.addressChanged()} width={this.props.width} ref={el => this.sidebarView = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "100%", md: '50%', lg: "33.3%", xl: "25%" }}>
                    <div className='h-100 scroll-no-scrollbar pb-5' style={{ backgroundColor: "#fff" }}>
                        <div className='w-100 flexcb px-2 py-1 position-sticky top-0' style={{ backgroundColor: '#fff', zIndex: 10, borderBottom: '1px solid #eee' }}>
                            <div className='flexc'>
                                <div className='mld-3'>
                                    <p className='font-size-18 text-bold '>{translate('Your addresses')}</p>
                                </div>
                            </div>

                            <div className='flexc'>

                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => this.sidebarView.close()}
                                    title={checkTranslation('Submit')}
                                    icon='/assets/icons/plus.svg'
                                    textColor={colors.textColor ?? '#000'}
                                    invert={colors?.iconInvert}
                                    bg={colors.background}
                                    isLoading={this.state.loadingPost}
                                />

                                <button className='mld-2 br-30 flexcc' style={{ background: '#ddd', height: 34, width: 34 }} onClick={() => this.sidebarView.close()}>
                                    <img src='/assets/icons/close.svg' height={20} />
                                </button>
                            </div>

                        </div>
                        <div className='container mt-3'>
                            {this.state.addresses.map((props, index) => {
                                let isSelected = false
                                if (this.state.selectedAddress?._id == props._id) {
                                    isSelected = true
                                }
                                return (
                                    <button onClick={() => { this.setState({ selectedAddress: props }); this.setState({ category: !this.state.category }) }} className={"my-2 d-flex w-100 p-3 text-start white-bg br-10 transition " + (isSelected ? "  blue-border " : " gray-border  ")}>
                                        <div className='mt-1 mrd-3'>

                                            <label className="checkbox-container " >
                                                <input type="checkbox" checked={isSelected} />
                                                <span className="checkmark"></span>
                                            </label>
                                            {/* <input type="checkbox" id="days" className="hour-checkbox mt-1" checked={this.state.selected == index} /> */}
                                        </div>
                                        <div className='w-100'>
                                            <div className='flexcb mb-1  w-100' style={{ marginTop: 3 }}>
                                                <p className='font-size-16 title-color text-semibold'>{checkTranslation(props.nickname)}</p>
                                                <button onClick={(e) => { this.openAddressForm(props, index) }}>
                                                    <p className='font-size-14 text-link cursor-pointer'>Edit</p>
                                                </button>
                                            </div>
                                            <p className='font-size-13 color-black'>{props.name} {props.family}</p>
                                            <p className='font-size-13 color-black '>{props.address}</p>
                                            <p className='font-size-13 color-black'>{props.city} {props.province?.name} {props.country?.iso2}</p>
                                            <p className='font-size-13 color-black'>{props.zipCode}</p>
                                            <p className='font-size-13 color-black'>{phoneStandardView(props.phone)}</p>
                                        </div>
                                    </button>
                                )
                            })}

                            {this.state.addresses?.length == 0 && (
                                <div className='pt-3 flexc flex-column'>
                                    <img src='/assets/icons/useful/leaf.png' height={70} />
                                    <p className='text-normal text-semibold mld-3 mt-2'>{translate("No address is submitted")}</p>
                                    <p className='text-small text-semibold mld-3 '>{translate("Please add a new address to proceed.")}</p>
                                </div>
                            )}


                            <div className={'mt-2 px-2 mb-2 ' + (this.state.addresses?.length == 0 ? 'flexc flex-column' : '')}>
                                <button onClick={() => this.openAddressForm()}>
                                    <p className='text-normal text-semibold text-link'>+ {translate("Add new address")}</p>
                                </button>
                            </div>

                        </div>
                    </div>
                </SidebarView>




                <SidebarView width={this.props.width} ref={el => this.addressFormSide = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "100%", md: '50%', lg: "33.3%", xl: "25%" }}>
                    <div className='h-100 scroll-no-scrollbar pb-4' style={{ backgroundColor: "#fff", }}>
                        <div className='w-100 flexcb px-2 py-1 position-sticky top-0' style={{ backgroundColor: '#fff', zIndex: 10, borderBottom: '1px solid #eee' }}>
                            <div className='flexc'>
                                <div className='mld-3'>
                                    <p className='font-size-18 text-bold '>{translate('Address')}</p>
                                </div>
                            </div>

                            <div className='flexc'>
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={this.submitAddress}
                                    title={checkTranslation('Submit')}
                                    icon='/assets/icons/angle-right-white2.svg'
                                    textColor={colors.textColor ?? '#000'}
                                    // invert={!this.colorss.colors?.iconInvert}
                                    bg={colors.background}
                                    isLoading={this.state.loadingPost}
                                />

                                <button className='mld-2 br-30 flexcc' style={{ background: '#ddd', height: 34, width: 34 }} onClick={() => this.addressFormSide.close()}>
                                    <img src='/assets/icons/close.svg' height={20} />
                                </button>


                            </div>

                        </div>
                        <div className=' mt-3'>
                            <FormViewer ref={el => this.addressForm = el} initData={this.state.currentAddressForEdit} headers={this.state.addressHeaders} formClass="bordered-form" inputClass={'bordered-input'} />
                        </div>
                    </div>
                </SidebarView>


            </div>
        )
    }
}




const mapStateToProps = state => ({ carts: state.carts, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CartDelivery);